// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/curve_coefficients.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/curve_coefficients.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_curve_coefficients: GenFile = /*@__PURE__*/
  fileDesc("CkBxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvY3VydmVfY29lZmZpY2llbnRzLnByb3RvEidxdWFudGVyaXguc2ltb2Ffb25lLmFuYWx5c2lzX2FwcF9hcGkudjEigQEKEUN1cnZlQ29lZmZpY2llbnRzEg4KAWEYASABKAFIAIgBARIOCgFiGAIgASgBSAGIAQESDgoBYxgDIAEoAUgCiAEBEg4KAWQYBCABKAFIA4gBARIOCgFnGAUgASgBSASIAQFCBAoCX2FCBAoCX2JCBAoCX2NCBAoCX2RCBAoCX2diBnByb3RvMw");

/**
 * Represents the coefficients of a generic curve equation
 * (e.g. y = ax + b) in common order, up to 5 parameters
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.CurveCoefficients
 */
export type CurveCoefficients = Message<"quanterix.simoa_one.analysis_app_api.v1.CurveCoefficients"> & {
  /**
   * @generated from field: optional double a = 1;
   */
  a?: number;

  /**
   * @generated from field: optional double b = 2;
   */
  b?: number;

  /**
   * @generated from field: optional double c = 3;
   */
  c?: number;

  /**
   * @generated from field: optional double d = 4;
   */
  d?: number;

  /**
   * @generated from field: optional double g = 5;
   */
  g?: number;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.CurveCoefficients.
 * Use `create(CurveCoefficientsSchema)` to create a new message.
 */
export const CurveCoefficientsSchema: GenMessage<CurveCoefficients> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_curve_coefficients, 0);

